/*
 * @Descripttion: 登陆相关外部接口  目前包括即时通讯相关内容
 * @version:
 * @Author: TangXihao
 * @Date: 2021-01-06 14:28:24
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-15 15:15:26
 */
import {
  LoginIn,
  SaveUser, AddTalkList,
  Register,
  GetFriendList,
  LoginOut, GetFriendApplication,
  AddRoomMessage,
  AddUserCache,
  AddRoomLastMsg,
  AddRoomUnReadMsg,
  ChangeRoom,
  ChangeActiveRoomName,
  DeleteTalkList,
  saveOnlineServiceId
} from '../store/actionCreators'
// import { saveLogin, saveuser, getLoginObj, getuser, initUserStore, gettalkList, getmessageList, getfriendList } from './localstore'
import axios from 'axios';
import NettyClient from '../utils/sdk';
import store from '../store';
import { message } from 'antd';
import { transformtime, customlog } from '../utils/tools';
import md5 from 'blueimp-md5'
import { talkEntityRec2talkEntity, message2talkEntity } from 'src/components/Pages/Chat/service/loaddata';
import { saveOnlineService } from '../store/actionCreators'
import pinyin from 'pinyin'
// import ApiUtil from '../Service/ApiUtil';
// import {saveTokens} from '../Util/storageToken'
const ipcRenderer = window.ipcRenderer
var fs = window.fs;
// *****  ****   *****************************************    *   *****
// *****   ***   **********         ***             ***           *****
// ****   ****   ****            *  ***********   ******      *   *****
// ****          ******   *      *  ********    *******               *
// ****  **       *****   *         *****      *  *******   **   *   **
// ***   **        ****   *      *  ***  *           ***         *   **
// ***    *  *      *            *  ***  **      *   *           *  ***
// **        *   *   **   *         ***  ***    **   ****   *    *  ***
// **  *     *   ******   ****   ******  *           *              ***
// *****    **   ******   ****   ******              ***   *        ***
// ******   **   ******              **  ***   *     ***      **    ***
// *****     *   ******     **   ******  **   ****   ***      **   ****
// ****   *    ******    *****   ******              *****          ***
// *     ****        *****           **              **    **    *    *
// **  *******************************************   **  ****  ****  **

const url = global.url
const gatewayip = global.gatewayip
// *******    ***************
// **         ***          **
// **           ********   **
// **    **   ****         **
// ***         *  ******    *
// *   ******   *           *
// ***        ***   *      **
// ***   **   *****       ***
// ****      ******       ***
// ****      ***    *       *
// *            ****    **  *
// **************************
//登录  登录的任务是获取token 和基础用户信息    保存到本地   然后加载数据到前端
export const login = (param) => async (dispatch) => {
  dispatch(LoginIn({ loading: true, tip: '', login: false }));
  let result
  //-----------------临时----------------------------------------------------------
  let userName = param.userName
  let userInfo
  console.log(param)
  try {
    userInfo = await loginRequset(param)
    console.log(userInfo)
  } catch (error) {
    dispatch(LoginIn({ tip: error, login: false }))
    console.log(error);
    return
  }

  //-------------------------------------------------------------------

  //调用登陆接口获取用户信息

  // let token = 'eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI0NTQ2MGVkMi05Y2Y1LTRjZDItYTUwNi1hMmNlNDcxYjM5OGIiLCJwYXlsb2FkIjoie1wicm9sZUlkXCI6XCIyMzIzM1wiLFwibG9naW5BZGRyXCI6XCJsb2NhbGhvc3RcIixcInVzZXJOYW1lXCI6XCLkvY_mtIvmiL_nmoRcIixcInVzZXJJZFwiOlwiMTAwXCIsXCJsb2dpblRpbWVcIjpcIjIwMjEtMDctMjBUMTM6NTY6MTQuNDA4XCIsXCJyb2xlTmFtZVwiOlwiYWRtaW5cIn0iLCJleHAiOjE2MjY3Njc3NzV9.-e1a_L3KzZ8fn0TslIESfL6FqC8kugfBF6xzkX4gpDE'//await loginRequset(param)
  // if (!token) {
  //   dispatch(LoginIn({ tip: '无此账户', login: false }))
  //   return
  // }

  // let user = result
  // .保存登录信息到本地
  // saveLogin({ tip: '', login: true })
  // saveuser(user)
  // dispatch(loaddata(user))

  console.log("登录信息到本地：（是否登录成功）")
  loadUserLocal(userInfo)

}
export const loadUserLocal = async (userInfo) => {
  // let user = await tokenCheck(token)

  if (userInfo) {
    // userInfo.userId = userInfo.userid
    // accessToken.userName = userInfo.username
    store.dispatch(LoginIn({ tip: '', login: true, token: userInfo.accessToken, userInfo: userInfo }))
    store.dispatch(SaveUser(userInfo))
    store.dispatch(loaddata(userInfo))

  }
}
// //用于测试的登陆接口
// export async function loginRequset({ userName, password }) {
//   return new Promise((resolve, reject) => {
//     axios.post(gatewayip + '/test/login', { userName, password }).then((res) => {
//       let data = res.data
//       if (data.code === 0) {
//         resolve(data.data)
//       } else {
//         reject()
//       }
//     }).catch((e) => {
//       reject(e)
//     })
//   })
// }
//yonghuxxhq
export async function tokenCheck(token) {
  return new Promise((resolve, reject) => {
    axios.post(global.yunguanurl + '/app/logincheck' + `?token=${token}`, null, {
      withCredentials: false
    }).then((res) => {
      let data = res.data
      if (data.code === 200) {
        resolve(data.data)
      } else {
        reject(data.message)
      }
    }).catch((e) => {
      reject(e)
    })
  })
}
//登陆接口
export async function loginRequset({ userName, password }) {
  // debugger
  // return new Promise((resolve, reject) => {
  //   axios.post(global.yunguanurl + `?userName=${userName}&password=${password}`, null, {
  //     // axios.post(`http://192.168.158.13:9527/api/system-manager/sys/user/login?password=${password}&username=${userName}`,null, {
  //     withCredentials: false
  //   }).then((res) => {
  //     // debugger
  //     let data = res.data
  //     // debugger
  //     console.log(res)
  //     if (data.code === "200") {
  //       resolve(data.payload)
  //     } else {
  //       message.warn(data.message);
  //       reject(data.message)
  //     }
  //   }).catch((e) => {
  //     console.log(e)
  //     reject(e)
  //   })
  // })
  password = md5(password)
  const { data: res } = await axios.post(global.yunguanurl + `?userName=${userName}&password=${password}`)
  console.log(res)
  if (res.code === '200') {
    return res.payload
  } else {
    message.error(res.message)
  }
}

// *****************************************************************************************************
// *******    *****************************  **   ******  **  *****   ***********   *  *****************
// **         ***          ***          ***   *   ****         ****          *      *  *  *           **
// **           ********   ***  ***********  **      **    *  *****     ***  **          **        *  **
// **    **   ****         ***  *********        *   *           *           **    ********           **
// ***         *  ******    **              *    *   *           **     *  ****     *    **           **
// *   ******   *           **  *********   *            *      ***           *    **    **          ***
// ***        ***   *      ***          *      *     *          **      *  ***  *         *          ***
// ***   **   *****       ****    ***   *   *  *     **  *      **           **    *   ****      *   ***
// ****      ******       ***     ***   *   *  ***   *     **   ***      **  *     *    ***          ***
// ****      ***    *       *  *        *      ***  ****        ***      **  ****    *   **           **
// *            ****    **  *  *  ***   *   *  *    **       *   *           **      **   ****     *   *
// *****************************************************************************************************
/**
 * 客户端的数据加载  ，  在本地有token及登录状态下  或  刚进行登录操作      进行数据加载到前端
.服务端读取
.获取好友列表
.更新好友列表
.获取聊天室列表
.从本地拉取 该用户下的 历史聊天室列表信息（以及聊天信息）
.比较差异 ， 按需更新？
.更新聊天室列表
.更新聊天信息
 */
export const loaddata = (user) => async (dispatch) => {
  // debugger
  console.log('开始数据加载-----')
  // .更新登录信息 到redux内存（页面显示使用）
  // dispatch(LoginIn({ tip: '', login: true }))
  // dispatch(SaveUser(user))
  store.dispatch(AddUserCache(user))
  //定位本地存储位置 到该用户文件夹下
  userconection(user)
  // initUserStore()
  // 获取好友列表                                               云端
  loadfriendList(user)
  //. 获取好友申请
  // setInterval(() => {
  getfriendapp(user,)
  // }, 100000)

  let messageList = []//getmessageList()
  messageList && dispatch({ type: 'loadlocalstore', data: { messageList: messageList } })

  // .从云端拉取 该用户下的 历史聊天室列表信息                                   云端
  gettalkListonline(user.userId)
  // // .从本地拉取 该用户下的  聊天信息）     本地
  // let messageList = getmessageList()


  // messageList && dispatch({ type: 'loadlocalstore', data: { messageList: messageList } })

}
/**
 * 登出
 */
export const logout = () => async (dispatch) => {
  if (global.client) {
    try {
      console.log("logout", global.client);
      for (let i in global.client) {
        console.log("global.client", i, global.client[i]);
      }
      // global.client.destroy()
      // debugger
      if (global.client.destroy) {
        console.log("global.client.destroy");
        global.client.destroy()
      }
      else if (global.client.__proto__.destroy) {
        console.log("global.client.__proto__.destroy");
        global.client.__proto__.destroy()
      }
    } catch (error) {
      console.log(error);
    }
  }
  dispatch(LoginOut())
  // // .保存登录信息到本地
  // saveLogin({})
  // saveuser({})
}
// ****************************************************************
// *******   *****   ************  ***********************   ******
// **   ***  *****          *****  ******        *   *****   ******
// ***          **  *****   *           ***   **     *           **
// ****               **   *****   ********          **         ***
// *    *       *     **  ******   *******   *       *****   ******
// **        ****  *         ***       ***  *                     *
// **        ****     **  *****    *  ***            ****    *  ***
// **     *  *  **   ***  ****        ******   *     **          **
// **          ***    **  ***   **   *******   ***   *         ****
// **   **     **      *  ***  **      ****   ****   * **        **
// **      **      ***    ****    ***        ****    ***   ****   *
// ****************************************************************
//调用后台接口 读取好友列表
export const loadfriendList = (user) => {
  // debugger
  if (!user) {
    user = store.getState().userReducer.get('user').toJS()

  }
  customlog('读取好友列表', 'start')

  axios.get(`${global.serviceUrl.chat}/friend/${user.userId}`).then(res => {
    let friendList = res.data.payload
    let friendListSimple = getFirstChar(friendList)
    friendListSimple.sort((a, b) => pinyin.compare(a.userName, b.userName))
    store.dispatch(GetFriendList(friendListSimple));
    // console.log();0
    friendList.forEach((frined) => {
      if (!frined.friendInfo)
        return;
      let user: User = {
        userId: frined.friendInfo.userId,
        userName: frined.friendInfo.userName,
        avatar: frined.friendInfo.avatar,
        phone: frined.friendInfo.phone,
      }
      store.dispatch(AddUserCache(user))
    })
    customlog('读取完成好友列表', 'end')

  }).catch((e) => {

    //------------------------------------------------------------------------
    //------------------------------------------------------------------------
    let friendList = defaultFrinedList.payload
    // debugger
    store.dispatch(GetFriendList(friendList))
    friendList.forEach((frined) => {
      if (!frined.friendInfo)
        return;
      let user: User = {
        userId: frined.friendInfo.userId,
        userName: frined.friendInfo.userName,
        avatar: frined.friendInfo.avatar,
        phone: frined.friendInfo.phone,
      }
      store.dispatch(AddUserCache(user))
    })
    //------------------------------------------------------------------------
    //------------------------------------------------------------------------

    // console.log(e)
  })
}

const getFirstChar = (data) => {
  // debugger
  let list = [];
  data.map((item, index) => {
    if (!item.friendInfo)
      return;
    let Letter = pinyin(item.friendInfo.userName.substring(0, 1), {
      style: pinyin.STYLE_FIRST_LETTER,
    });
    let firstLetter = Letter[0][0].toUpperCase();
    item.friendInfo.firstLetter = firstLetter
    list.push(item.friendInfo);
  });
  return list;
}
/**调用后台接口 读取好友请求*/
export const getfriendapp = (user) => {
  if (!user) {
    user = store.getState().userReducer.get('user').toJS()
  }
  axios.get(`${global.serviceUrl.chat}/apply/user/${user.userId}`).then((data) => {
    let applylist = data.data.payload
    store.dispatch(GetFriendApplication(applylist))
  }).catch((e) => {

  })
}
// ****************************************************************
// *******   ********  *******  **************************   ******
// **   ***  ********   ******          *        *   *****   ******
// ***          ****     ******  **   *****   **     *           **
// ****         **   **   *********   *****          **         ***
// *    *       *                        *   *       *****   ******
// **        ***  ************  ***   ****  *                     *
// **        ****           **  ***   ***            ****    *  ***
// **     *  *  ****   *******  *       ****   *     **          **
// **          ****      *****     **   ****   ***   *         ****
// **   **     ***   ***  ****          ***   ****   * **        **
// **      **   **         ***  *  **   *    ****    ***   ****   *
// ****************************************************************
/**
 * 调用后台接口 读取会话列表   外加历史记录
*/
export function historyMessage2LocalMessage(msg) {
  let user = store.getState().userReducer.get('user').toJS()
  let mess = {
      content: msg.content,
      type: msg.contentType,
      roomId: undefined,
      receiverId: msg.receiverId,
      time: msg.createTime,
      userId: msg.senderId,
      messageId: msg.serial,
      contactType: msg.messageType
  }
  let roomId
  if (user.userId === mess.receiverId) {
      roomId = mess.userId
  } else {
      roomId = mess.receiverId
  }
  switch (mess.contactType) {
      case 'public':
          mess.roomId = '/group/' + roomId;
          break;
      case 'private':
          mess.roomId = '/private/' + roomId;
          break;
  }
  return mess
}
export const gettalkListonline = (userId) => {
  return new Promise((resolve, reject) => {
    if (!userId) {
      userId = store.getState().userReducer.get('user').toJS().userId
    }
    customlog('调用后台接口 读取会话列表', 'start')
    let messageList = store.getState().messageReducer.get('messageList').toJS()
    axios.get(`${global.serviceUrl.chat}/contact/${userId}`)
      .then((data) => {
        let talkList = data.data.payload
        // .更新聊天室列表
        customlog('成功读取会话列表', 'end')
        talkList && talkList.forEach((element) => {    //添加到前端
          //     // if (element.senderId === userId) {
          let chat = talkEntityRec2talkEntity(element)
          store.dispatch(AddTalkList(chat))
          if (chat.type === 'public') {
            store.dispatch(ChangeActiveRoomName(chat))
          }

          // // 从云端拉取聊天记录-------------------------------------------------
          let roomMessageList = messageList[chat.roomId] || [] //redux中读取消息
          let lastLocalMessageTime = new Date(0)
          let roomlastMsg = new Object()
          if (roomMessageList && roomMessageList.length > 0) {
            roomlastMsg = roomMessageList[roomMessageList.length - 1]
            lastLocalMessageTime = roomlastMsg.time
          }

          // customlog(`判断房间${chat.roomId}有无最新消息`, 'start')
          if (new Date(chat.lastMsgTime).getTime() >= new Date(lastLocalMessageTime).getTime() + 10) {

            if (element.lastMessage !== roomlastMsg.content) {
              customlog(chat.roomId + '有最新消息,开始读取', 'start')
              getmessagehistory(chat, (data) => {
                // console.log("最新获取的历史消息：",data);
                let msl = data.data.payload.records
                for (let index = 0; index < msl.length; index++) {
                  const msg = msl[index];
                  let time = new Date(msg.createTime)
                  if (time.getTime() >= new Date(lastLocalMessageTime).getTime()) {
                    let mess = historyMessage2LocalMessage(msg)
                    dispatchmessage(mess)
                  }
                }
                customlog(chat.roomId + '最新消息,读取完成', 'end')
              })
            }
          }
          //------------------------------------------------------------------
        });
        resolve(talkList)


      }).catch((e) => {
        // debugger
        console.log('读取会话列表失败 原因是 ' + e, 'end')
        // let talkList = defaultTailList.payload
        // // .更新聊天室列表
        // talkList && talkList.forEach(element => {
        //     let chat = talkEntityRec2talkEntity(element)
        //     store.dispatch(AddTalkList(chat))
        // });
        reject("读取会话列表失败");
      })
  })
}
/**
 * 读取历史消息
 * @param {} chat
 * @param {*} callback
 */
const getmessagehistory = (chat, callback) => {
  let user = store.getState().userReducer.get('user').toJS()
  // if (chat.type === 'public')
  console.log(chat.type)

  console.log("会话记录：",chat)
  axios.get(`${global.serviceUrl.chat}/message/${chat.type}`, {
    params: {
      senderId: user.userId,
      receiverId: chat.receiverId,
      groupId: chat.receiverId,
      page: 1,
      limit: 10
    }
  }).then((data) => {

    callback(data)
  }).catch((e) => {
    console.log(e)
    message.error(e + 'action.js l404')
  })

}
// **************************************************
// **************************  **********************
// **************************  ****************  ****
// **************************  ****************  ****
// **************************  ****************  ****
// *       **      **      **  *    **      *       *
// *   *   *   **      **   *     ***   *   ***  ****
// *    ****   **      ******     ***       ***  ****
// ***     *   **      ******     ***  ********  ****
// *   *   *   **      **   *  *   **   **   **  ****
// *   *   *       **       *  **   *       ***     *
// **     ****    ****    ***  **   **     *****    *
// **************************************************
const userconection = (user) => {
  
  let client = new NettyClient({ url: global.serviceUrl.ws, maxRetryTimes: 5 });
  client.connect({
    userId: user.userId, userType: "Servicer"
  })
  client.on('SERVICER', mes => {
    let answerMessage1 = {
      flag: "1",//1表示客服回答的内容
      info: mes.content
    }
    store.dispatch(saveOnlineService(answerMessage1))
  })
  client.on('SERVICE_START', mes => {
    let answerMessage1 = {
      flag: "1",//1表示客服回答的内容
      info: '客服' + mes.content + '号为您服务'
    }
    store.dispatch(saveOnlineService(answerMessage1))
    store.dispatch(saveOnlineServiceId('人工客服' + mes.content + '号'))
  })
  client.on('SERVICE_STOPED', mes => {
    let answerMessage1 = {
      flag: "1",//1表示客服回答的内容
      info: mes.content
    }
    store.dispatch(saveOnlineService(answerMessage1))
  })

  client.on('PEOPLE', mes => {
    let answerMessage1 = {
      flag: "1",//1表示客服回答的内容
      info: '前方有' + mes.content + '人正在排队'
    }
    store.dispatch(saveOnlineService([answerMessage1]))
  })
  client.on('PUBLISH', msg => {
    // debugger
    getuserinfo(msg.sender)
    dispatchmessage({
      content: msg.content,
      type: msg.contentType,
      roomId: msg.topic,
      // command:msg.command,
      time: msg.time,
      userId: msg.sender,
      messageId: msg.serial,
      contactType: 'public'
      // avatar:user.avatar
    })

    ipcRenderer && ipcRenderer.send('open-error-dialog');

  })
  client.on('SEND', msg => {
    dispatchmessage({
      content: msg.content,
      type: msg.contentType,
      roomId: '/private/' + msg.sender,
      // command:msg.command,
      time: msg.time,
      userId: msg.sender,
      messageId: msg.serial,
      contactType: 'private'
    })
    getuserinfo(msg.sender)
    ipcRenderer && ipcRenderer.send('open-error-dialog');

  });
  client.on('IM_USER_APPLY', msg => {
    // debugger
    getfriendapp(user)
    // console.log(msg)
  });
  global.client = client
}
// /**
//  * 群聊消息更新到 前端
//  * @param {*} mess
//  */
// const dispatchpublicmessage = (mess: ReceiveMesssgeEntity) => {
//   store.dispatch(AddRoomMessage(mess))//将消息添加到消息树
//   //判断信息列表是否有对应聊天室，没有需要先加上去（向服务器订阅 后 重读 消息列表） 还的是同步的（成功后再进行下面两条）
//   // store.dispatch(AddTalkList(mess))
//   store.dispatch(AddRoomLastMsg({ roomId: mess.roomId, message: (mess.type === 'text' ? mess.content : mess.type === 'img' ? '[图片]' : mess.type === 'file' ? '[文件]' : ''), userId: mess.userId, lastMsgTime: mess.time }))//将消息添加到消息树
//   store.dispatch(AddRoomUnReadMsg({ roomId: mess.roomId }))//将消息添加到消息树

// }

// *******************************************************************
// ****   **   ******************   **  ******  ***********   ********
// ****   **  *******         ***  **        *  *    *****   *********
// *      *   *********   ****  *  ****      *  *   ***            ***
// *      *         ***      *  *  ********        ****   ******   ***
// *         **   ****   *   *  *  ***********  *******            ***
// *          *   **    *       *  **    *          ***   ******   ***
// *          *  ****           *  ***   *   ****   ***            ***
// *      **     *******   ***  *  *******          ***   ******   ***
// *      **     *******   ***  *  ****  *          ***            ***
// *      **    *****           *  ****      ****   ********  ***  ***
// *  *   ***   ********   ***  *  ***   *          **         **   **
// ****   **     *******   *  ***  ***   *   ****   **      *  ***   *
// ****   *       **          ***  **    *   ****   **  *   ***      *
// ****      ***    *   *******    **   **   ***    *   *         ****
// ******  ********************   ********   ***  ********************
// *******************************************************************　　　　　　　　　　　　　　　
/**
 *  将得到的  消息 更新到 前端
 * @param {*} mess
 */
export const dispatchmessage = async (mess) => {
  if (mess.type === 'file') {

  }
  //将消息添加到消息树
  // store.dispatch(AddRoomMessage(mess))

  let user = store.getState().userReducer.get('user').toJS()
  let has = store.getState().userReducer.get('talkList').find((item) => {
    return item.get('roomId') === mess.roomId
  })
  /**   * 会话对象  */
  let chat = message2talkEntity(mess)
  // debugger
  if (!has) {//来自    未订阅(或刚订阅但为重载会话列表时)的房间、会话
    // let usercache = store.getState().cacheReducer.get('usercacheList').toJS()
    let str = mess.roomId;
    const regex = /[0-9]+/;
    let receiverId = str.match(regex)[0];
    if (mess.contactType === 'private') {//如果人对人的消息 实际发送方id  才是我需要订阅的会话id
      receiverId = mess.userId
    }
    // debugger
    // let talkEntity = await addchat(receiverId, mess.contactType)//, (element) => { //实际上会有没有订阅的情况（比如啦群时正好不在线，或者删除了会话）就需要重新订阅  理论上后台自动让所有成员订阅 不再额外订阅
    // chat.avatar = talkEntity.contactAvatar
    // chat.chatName = talkEntity.contactName
    store.dispatch(AddTalkList(chat))
    store.dispatch(AddRoomLastMsg(chat))//将消息添加到消息树
    store.dispatch(AddRoomUnReadMsg(chat))//将消息添加到消息树
    store.dispatch(AddRoomMessage(mess))
    //})
    // }
  }
  else {
    store.dispatch(AddRoomLastMsg(chat))//将消息添加到消息树
    store.dispatch(AddRoomUnReadMsg(chat))//将消息添加到消息树
    store.dispatch(AddRoomMessage(mess))
  }

}

// ***************************************************
// ***   ****   ******   *********  ******  **********
// *            *          ******   ******          **
// *******   *****  **     *****     ******  **   ****
// **        *****          ***   **   ********   ****
// *            *          **                        *
// ***   *     **    *   ***   ***********   **   ****
// *           **          **           **   **   ****
// **    *     **    *   ********  *******          **
// **       *  ***          ****      ****      **  **
// *        *  **        ******  ***   ***          **
// **       *  *   *        **          **  *   **  **
// ***************************************************
/**
 * 增加新的会话    不会改变当前激活房间 （需要自己另写），会将房间添加到会话列表
 * @param {*} touser 目标人/群
 * @param {*} type 人/群  "private"/"public"
 * @param {*} callback 回调 参数是 订阅的会话 房间信息
 */
// export const addchat = (touser, type, callback) => {
//   debugger
//   return new Promise((resolve, reject) => {
//     // debugger
//     let user = store.getState().userReducer.get('user').toJS()
//     let data = {};
//     data.contactType = type;
//     data.senderId = user.userId;//订阅者
//     data.receiverId = touser.userId;//群号、好友号
//     data.contactName = touser.userName;
//     data.contactAvatar = touser.avatar;
//     data.serial = ''
//     console.log(data);
//     // {
//     //     "serial": "",
//     //     "contactType": type,
//     //     "senderId": user.userId, //订阅者
//     //     "receiverId": touser,//群号、好友号
//     //     "contactName": touser.userName,
//     //     "contactAvatar": touser.avatar
//     // }
//     axios.post(`${global.serviceUrl.chat}/contact/save`,data).then(async (res) => {
//       debugger
//       let room = res.data.payload;
//       let chat = talkEntityRec2talkEntity(room);
//       store.dispatch(AddTalkList(chat));
//       // callback && callback(room)
//       // gettalkListonline(user.userId)
//       resolve(room);
//     }).catch((e) => {
//       console.log(e);
//       reject()
//     })
//   })
//   // let user = store.getState().userReducer.get('user').toJS()
// }
export const addchat = async (touser, type, callback) => {
  // debugger
  let user = store.getState().userReducer.get('user').toJS()
  let data = {};
  data.contactType = type;
  data.senderId = user.userId;//订阅者
  data.receiverId = touser.userId;//群号、好友号
  data.contactName = touser.userName;
  data.contactAvatar = touser.avatar;
  data.serial = ''
  const { data: res } = await axios.post(`${global.serviceUrl.chat}/contact/save`, data)
  // debugger
  if (res.code === '200') {
    console.log(res)
    let room = res.payload;
    let chat = talkEntityRec2talkEntity(room);
    store.dispatch(AddTalkList(chat));
    if (chat.type === 'public') {
      store.dispatch(ChangeActiveRoomName(chat))
    }
    return room
  }
}
// export const loadmessage = (roomId) => {
//   if (roomId.indexOf('/group/') != -1) {
//     roomId = roomId.replace('/group/', '')
//     axios.get(`${global.serviceUrl.chat}/message/public`, {
//       params: {
//         page: 1,
//         limit: 20,
//         groupId: roomId
//       }
//     }).then((data) => {
//       debugger
//       let messageList = data.data.payload
//       // store.dispatch(AddTalkList())
//     }).catch((e) => {
//     })
//   }
// }


// ***************************************************
// ********  ******** **  *********   *******   ******
// ***  *     ***      *   **            ****  *******
// **      *  ****  *     ****          **          **
// **           ****       ********   ****          **
// *****  ************   ****           **   ****   **
// ****        *            **  *  ***  **          **
// ****   **  ****  **   *****  *       **          **
// ***        ****  *     ****     ***  ****    **  **
// **   *    *****     **   **  *       **          **
// *   **    ****    ********   *  ***  *     **     *
// ***    *                 *  *   **   *  *      ****
// ***************************************************
/**
 * 群聊 发消息
 * @param {} url 群组id
 * @param {*} content
 * @param {*} type 信息的类型
 */
export function sendmessagepublic({ url, content, type }) {
  global.client.publish(url, content, type).then(res => {
    console.log('publish succeed');
    // debugger
  }).catch(res => {
    message.error('消息发送失败')
    console.log('publish failed');
  }).finally(() => {
    console.log("群发动作完成，无论成功与否");
  });

}
/**
 * 私聊 发消息
 * @param {} targetuserId 对方用户id
 * @param {*} content
 * @param {*} type 信息的类型
 */
export function sendmessageprivate({ targetuserId, content, type }) {
  let user = store.getState().userReducer.get('user').toJS()

  // let room = store.getState().userReducer.get('activeRoom')//这里不能用activeroom来做。。
  global.client.send(targetuserId, content, type).then(res => {
    let mess = {
      content: content,
      type: type,
      roomId: '/private/' + targetuserId,// room.roomId,
      time: res.time,
      userId: user.userId,
      messageId: res.serial,
      contactType: 'private'
    }
    dispatchmessage(mess)
    console.log("send succeed");
  }).catch(res => {
    // let mess: ReceiveMesssgeEntity = {
    //   content: content,
    //   type: type,
    //   roomId: room.roomId,
    //   time: res.time,
    //   userId: user.userId,
    //   messageId: res.serial
    // }
    // dispatchprivatemessage(mess)
    message.error('消息发送失败')
    console.log("send failed");
  })
}

// ***************************************************
// ******************   ******  ******  *****   ******
// **          *******  ******          *****  *******
// **   *  **  ***          *           **           *
// **          ***  *****   *      **  *****  ********
// **   *  **  ***  *****   *           ***         **
// **   *  **  ***  *****   **           *   ****  ***
// **          ***          *    *  *****    ***  ****
// **   *  **  ***  *********   *       *            *
// **  **  **  **   **********         ****  ***  ****
// **  **  **  **   *********         *****  ***  ****
// *   **     **   ************         ***  **   ****
// ***************************************************
/**
 * 拉取单个特定用户信息  并到缓存
 * @param {*} userId
 */
export const loaduserinfo = (userId, callback) => {
  axios.get(`${global.serviceUrl.service}/sys/user/${userId}`).then((data) => {
    // debugger
    let userdata = data.data.payload
    let user: User = {
      userId: userdata.userId,
      userName: userdata.userName,
      avatar: userdata.avatar,
      phone: userdata.phone,
    }
    store.dispatch(AddUserCache(user))
    callback(user)
  }).catch((e) => {
  })

}
/**
 * 获取用户信息 如果没有就添加到缓存
 */
export const getuserinfo = (userId, callback) => {
  let usercacheList = store.getState().cacheReducer.get('usercacheList').toJS()
  let user = usercacheList[userId]
  if (user) {
    return user
  } else {
    loaduserinfo(userId, callback)
    // return user
  }
}
let filecache = []
export const checkfileexist = ({ path }) => {
  let file //= filecache.find(file0 => file0.path === path)
  // if (!file) {
  try {
    let stats = fs.statSync(path);//如果文件已存在读取文件信息
    if (stats) {//如果文件已经存在并且已经下载按成则跳过该文件
      file = {
        path,
        process: 100,
        filesize: stats.size
      }
      // filecache.push(file)
    }
  } catch (err) {

  }
  // }
  return file || { process: 0 }
}
export const addfilecache = ({ path, process, filesize }) => {


}

// ***   **   *   *****   *******   ****     *  ********  ************
// ***   **      ******        **   **           *******  *         **
// ***   *** *   *****   *   *      ***         ********  *   ****  **
// ***   *         ***   *   *      *               ****  *   ****  **
// *       **   *****    *  **      ***    **   *  **               **
// ***   ****   *****    *          **         *   *****  *   *   ****
// **              *                *              *****      *   ****
// **      **   ******     *        ****           ****              *
// *       **   ******              *        *     **     *   *   ****
// *     ****   ******   **         ***      *    **** *  *         **
// *                **   **         **   *   *    ******  *    ***  **
// ***   ****   ******   *   ****   **       **   ******       ***  **
// ***   ****   ******       ****   ****           *****       ***  **
// ***   ****   ******      ***     **    **   **   **      *       **
// **********   ******     **********   ***   ****  ********   *******

//用户数据
const users = [
  {
    "userId": 100,
    "userName": "总管理",
    "password": "$2a$10$x4neVqXTVO96/AxKEqIzkeBw3VgSKtEXTQ5JXyR0gLpferuQYk9Sa",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-15T14:40:07.408084",
    "updateTime": "2021-01-15T14:40:07.408084",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 18,
    "userName": "安娜18",
    "password": "$2a$10$x4neVqXTVO96/AxKEqIzkeBw3VgSKtEXTQ5JXyR0gLpferuQYk9Sa",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-15T14:40:07.408084",
    "updateTime": "2021-01-15T14:40:07.408084",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 5,
    "userName": "赵四5",
    "password": "$2a$10$RayDCQVhKWwuRf2utlGoXusHkLSoFY71BBOraIO.eHqMdXmjwsXfe",
    "salt": "1234",
    "phone": "1928987143",
    "avatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
    "createTime": "2021-01-06T14:18:19.618671",
    "updateTime": "2021-01-06T14:18:19.618671",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 6,
    "userName": "赵六6",
    "password": "$2a$10$avg5VKfOWsnqOuMkvhhs4unOJnXA6r0Ay1nqMT6VIk.7EHrKF3Ow6",
    "salt": "eislklsjfi",
    "phone": "152xxxx2120",
    "avatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
    "createTime": "2021-01-06T14:18:49.988726",
    "updateTime": "2021-01-06T14:18:49.988726",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 19,
    "userName": "安娜19",
    "password": "$2a$10$hweNWVF/GElM45I30U0IG.Jx6.KSBWyHOuhKxkF/lO8vQX.BnHkFO",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-15T14:40:10.844082",
    "updateTime": "2021-01-15T14:40:10.844082",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 7,
    "userName": "小三7",
    "password": "$2a$10$M9g7YPQBgLbbyQYifKJBs.yRNiSkwk7z2CJ.Lv/8uMXfUTEbt.IXW",
    "salt": "eislklsjfi",
    "phone": "152xxxx2120",
    "avatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
    "createTime": "2021-01-06T14:18:58.98793",
    "updateTime": "2021-01-06T14:18:58.98793",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 20,
    "userName": "安娜20",
    "password": "$2a$10$wbDC2WcSXmCoYn.JtA/wKeMy/pxEsOfaNed6JK48B7AQavw4nC8ay",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-15T14:40:15.113048",
    "updateTime": "2021-01-15T14:40:15.113048",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 8,
    "userName": "马六8",
    "password": "$2a$10$An2pSiQhupfuPNXlSXvAbO0J1YJNKYXFoMPtfQsMnOCteqjfZEMPa",
    "salt": "12314",
    "phone": "19113872143",
    "avatar": "http://p6.itc.cn/images01/20201224/d682a76d7ac241f0a874e258752d17e7.jpeg",
    "createTime": "2021-01-06T14:19:41.758956",
    "updateTime": "2021-01-06T14:19:41.758956",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 9,
    "userName": "赵云9",
    "password": "$2a$10$/2z0IfUqRCQAfN3MUFlhHeM5VvFOn0qZAuVPW/ozSgf3tlErFynBi",
    "salt": "1378",
    "phone": "19113872543",
    "avatar": "http://p5.itc.cn/images01/20201224/4fc9fd34d2e44302b25d16916c4c9fd7.jpeg",
    "createTime": "2021-01-06T14:20:12.748304",
    "updateTime": "2021-01-06T14:20:12.748304",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 10,
    "userName": "安娜*莎妮亚特10",
    "password": "$10$kNuq6jetBa4jsChfTgkQFuDVsG92BXBbwLDk/mosBOn2FFrPJ83em",
    "salt": "xhf",
    "phone": "138xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-06T19:34:33.538938",
    "updateTime": "2021-01-06T19:45:10.383",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 12,
    "userName": "琪亚娜12",
    "password": "$2a$10$tZtEInlW7BxntwcGY9FlVemB2MBsHTEVV2HyvQl2gWk9dnkPWwD4C",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-06T19:54:28.75672",
    "updateTime": "2021-01-06T19:54:28.75672",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 15,
    "userName": "安娜15",
    "password": "$2a$10$5atQkMdb3W8pVRViZiPc0OI1IfTjBcsuK5Kt4V4sX1tHDZjfitTPu",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-15T14:34:49.878348",
    "updateTime": "2021-01-15T14:34:49.878348",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 13,
    "userName": "超级管理员13",
    "password": "$2a$10$iSg5.ccgIOF5vdep18BgNui9D8vlCQ/fPi4FYbeOWLc7RJWFkglSq",
    "salt": "xhf",
    "phone": "138xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-06T21:20:18.970161",
    "updateTime": "2021-01-06T21:22:30.435",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 4,
    "userName": "王五4",
    "password": "$2a$10$k8pb8plumdsEPGuU3hYMOukmNas6uPnrM36w7iTw913Ls2FH.baAS",
    "salt": "eislklsjfi",
    "phone": "152xxxx2120",
    "avatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
    "createTime": "2021-01-06T14:18:14.328061",
    "updateTime": "2021-01-06T19:53:55.981",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 11,
    "userName": "陈天武11",
    "password": "$2a$10$kNuq6jetBa4jsChfTgkQFuDVsG92BXBbwLDk/mosBOn2FFrPJ83em",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-06T19:41:35.641501",
    "updateTime": "2021-01-06T19:41:35.641501",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 16,
    "userName": "安娜16",
    "password": "$2a$10$NGp/VIm3.4566w6uEb3ar.tJf1NjJ1rF7BXTsARfQyLXnLvf.Gw/K",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-15T14:34:55.553351",
    "updateTime": "2021-01-15T14:34:55.553351",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 14,
    "userName": "安娜14",
    "password": "$2a$10$CFgL4QGJxWrV.lENl1MZmOeMiJowZc0G1/5qyp.vxwv/c9pi6fBYu",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-15T14:34:43.398252",
    "updateTime": "2021-01-15T14:34:43.398252",
    "lockFlag": "0               ",
    "delFlag": "0"
  },
  {
    "userId": 17,
    "userName": "安娜17",
    "password": "$2a$10$DD1m2AU96.YVy3VxMcCuPOn./T2p9nECyGJ.hylepEL70v/yFzMpq",
    "salt": "xhf",
    "phone": "152xxxx1234",
    "avatar": "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=921151223,1267112089&fm=11&gp=0.jpg",
    "createTime": "2021-01-15T14:40:03.486421",
    "updateTime": "2021-01-15T14:40:03.486421",
    "lockFlag": "0               ",
    "delFlag": "0"
  }
]

const testtalkList = [
  {
    "serial": "1348463873921212417",
    "contactType": "private",
    "senderId": 4,
    "receiverId": 6,
    "contactName": "小王-Updated",
    "contactAvatar": "http://demo.com/xxx.png",
    "lastMessage": "hello",
    "lastMessageTime": "2021-01-12T14:32:43.4",
    "createTime": "2021-01-11T16:51:07.918521",
    "updateTime": "2021-01-11T16:51:07.918521"
  },
  {
    "serial": "1349175387879043074",
    "contactType": "private",
    "senderId": 4,
    "receiverId": 5,
    "contactName": "五湖四海皆兄弟2",
    "contactAvatar": "http://demo.com/xxx.png",
    "lastMessage": "你们已经成为好友啦！快来聊天吧！",
    "lastMessageTime": "2021-01-13T10:04:13.601901",
    "createTime": "2021-01-13T10:04:13.601901",
    "updateTime": "2021-01-13T10:04:13.601901"
  },
  {
    "serial": "1349175360318271490",
    "contactType": "public",
    "senderId": 4,
    "receiverId": 4,
    "contactName": "五湖四海皆兄弟",
    "contactAvatar": "http://demo.com/xxx.png",
    "lastMessage": "你们已经成为好友啦！快来聊天吧！",
    "lastMessageTime": "2021-01-13T10:04:07.050588",
    "createTime": "2021-01-13T10:04:07.050588",
    "updateTime": "2021-01-13T10:04:07.050588"
  },
  {
    "serial": "1348463873921212434",
    "contactType": "public",
    "senderId": 4,
    "receiverId": 5,
    "contactName": "测试群",
    "contactAvatar": "http://demo.com/xyz.png",
    "lastMessage": "hello",
    "lastMessageTime": "2021-01-12T11:04:04.521192",
    "createTime": "2021-01-12T11:04:04.521192",
    "updateTime": "2021-01-12T11:04:04.521192"
  }
]
//
const defaultTailList = {
  "code": "200",
  "message": "User's contacts",
  "payload": [
    {
      "serial": "1348463873921212434",
      "contactType": "public",
      "senderId": 4,
      "receiverId": 5,
      "contactName": "测试群5",
      "contactAvatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
      "lastMessage": "hello wor",
      "lastMessageTime": "2021-01-19T15:46:34.876",
      "createTime": "2021-01-12T11:04:04.521192",
      "updateTime": "2021-01-12T11:04:04.521192"
    },
    {
      "serial": "1349175360318271490",
      "contactType": "public",
      "senderId": 4,
      "receiverId": 4,
      "contactName": "测试群4",
      "contactAvatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
      "lastMessage": "我敢",
      "lastMessageTime": "2021-01-19T15:36:35.563",
      "createTime": "2021-01-13T10:04:07.050588",
      "updateTime": "2021-01-13T10:04:07.050588"
    },
    {
      "serial": "1349651798877650946",
      "contactType": "private",
      "senderId": 5,
      "receiverId": 6,
      "contactName": "赵六6",
      "contactAvatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
      "lastMessage": " <img  src='data:image/png;base64,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'> 1",
      "lastMessageTime": "2021-01-19T09:16:34.581",
      "createTime": "2021-01-14T17:37:18.830005",
      "updateTime": "2021-01-14T17:37:18.830005"
    },
    {
      "serial": "1349650942610489346",
      "contactType": "private",
      "senderId": 5,
      "receiverId": 6,
      "contactName": "赵六6",
      "contactAvatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
      "lastMessage": " <img  src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABACAIAAAARcieVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAgAElEQVR42mW7aZBc2XUmds7d3pYvMysza0VVYW+ggQaIbjS60Qt7Idlkc9NCkTOiJhQeezzhPx57wuNfMxEOh//4x3g8tmXNYjkki5RIiZRIUSIlkWySze5Gr+wNQGMroFCF2quycn/rXY5/JKjxeF68vPkiXsSLzPvu+e453/cdXHjhk0TEw4gpCYwjIHgKGAPGzChFhiysoGD1T36m+tQzTEgmJCHmayvJ9Y/0fpuMBkREjkLoXgcBAUBOz9o0AQBRrbmycFlOziFDIkJkwBCFZJ7HlEfOMj8AIiYkAABjgDh+JhABADjnjCl3tsv2HmhdbG398tb49i8Pa4Ex/8B89fwF7qmy2yNjiIi0tlmK4ACAAAEIHTlj9P4eOHJam0G/2NwotrcFAQAikGPK43HNISICMAbO8bhGxqrpGRZFzA8QEDbWLt768O5jz2xOzTA/HF39AIiQC3DEwsCHwyKuolSASFqjEM4YOxoiYy4vnC6AiKwl51xRoJCAyJSHAIRIQCgEMoZCkOCASMYgY64s0VoRxygFOBKNpohjcg6FtMmIjAHniu0tVxTVRx6VjWas8+alH61ceNZKQUkK4ICAEAEAx5OHiMiYH5AuGQALfFGvE5EAAOb7ojnJowiUx4jIGBSCjGFRBZFhECAXLk0A0ff991760fx77xz6rX90tzVbffRidvsmGSubTeYHwLicmGC+D4jkHBlDWtvh0AwHLsuc1rq964rCjIYuywEREBkXvFZDzrkfAHPAGBkzXgikDTmLnifiWE1P21ECAIAoG43xIrLJSO+3y/394MhRUa8DQO3aB4euvzus1LxDR4qNdQdEjhAJAAmIiBARAIAjMk4EKJWIq4iMKU+gEDyqoBCADMbz5fvAOPo+D0P0A+b5iOjyAgiKeuPAyQevv/rzp77zx+oLX1k6fCI8eRqsRc9HxlAKZBw5Z0QWERQBEa/EstUyvZ7e3wdyNs+B87LYBecAUbZazPOAgPneOC4AgJxDRJSChzXZaPIwZMqzaUKjEZLDIHSMkTG8EgMAjyosDMX+XuvST6ba60RUtmaDI8fK9i5YR7okQgRAJGAI45BCRClAcwBA4CyqcOcEEwI5R6XGawYYopTAOA8CVqsjF+P3g0IAEEmlFw5PLNx9+Y03nrX29K/+/RunHyFrWJo28myh3T1Q5NN5XgfHmy0RVUql7iFf5vJaozGamHB5UbZ3cyI7HLqyZL6PnI///P3IZwzH8SIEjyI1Nc0Yc9tbtHqX9XuQZqRL8H0RBFSJXRC6IBD1evW9N6uXfloNJHI2GGT67HnmKbJE5MC6+w8HBAJAGM8Jcg5A41WJANwPBPM8sBYQgPPxiUICFyAUcnH/V3IOiDZNhfKy6dnJ4w+0V1d+/sbrXwhDWeTrp889ubWyOOgGuhREnlJlWWbtnU6aMiGOz8w8OTvvwugNSx8S3j5wQLUms0bT9PvIGPM85vtMecA5AKCUyDkZA4hMCnPzWvdb3xjdWSq7naK954oCEACRSanieObZT9U//TkY9EkqOT2Fw25SkrPWHj5KxoDVriycMeOFhojAxkDhAAmRMenZsgAiYEjOCVQeMAaEyAUwhkKAlCKugu//f0AZ0fNsvycmGtmBg+yj9+fPnLtz6eWfXbr02SA4sb+1GAZo3SgZJelgbm5+ema2Glel9LIs3dnZ+eC1l4VSjz109tla/VJS/nk0oY4fzzY2KEtQG9fewe0N3uuKMsc8g2QEowFZg0wYY+TSzaAsdX+f64KsdsY4ayxh2dm/+80/9H/6t9VHHpv50m/uXPxU/bUfsrwD5FxzirRGpVySkimBkBgC51wp4AxoDJkADBEIEJwlABAAhFKBs8AZ83xWqfAwhHFEAAARCsEqFaY8lBIZs1PT2g+qBw4EtUanvfPyz3/+WeVdTUeXXnvl8pWPiJyzxDhvNhpnP/ax8+cfOXP27ENnzxZFsXZniSH7+ImTsc6/v3ovufSK3lzDvR1ypjA0HAy6/UGWJEZb5xwAAQEAcCGUFNNR4DVq1rmt3b3RMDXGkiNTlKO1tWKvnS3dXPgn/4w9+kztJ39F9QYpRcmIB6HLMwJAxsAQGQPGsChEAgAg6+5vItaC1q7IefPxx1kQMt8Xk9MsDHkQMOWhUkx5yDkAsjBC5alWS05Oo+ehkGZnuzLsVeK4s3ZvZ2tLCD5Rr95bW7t5cynL8iLL0yztdDo3btz4+cs/+9EPf7i9vVapBnMHZjnnN2/eOFmv0Xtv333zNdftcKIsSZeX7nT29pPBKEvTIi9KrctSa62NtVqXRVlmWZlkeVnqShhNT7d8XxlrnXNE5Iwxve7o8vu1z36RGpOyzItnXnBal9tbZjBwRT4GPjKWjOGeB4BAjqxxxpDWQETGmsGAt556GhkTjaaYaPCowpQv6hM8inmtzuOYhaGIKqJel9OzzPN4VMmvXun+5MdztciLKjoZoTUHWg0A+usf/NCR45wzNh4YQwTEIi9u3lpaW7135Njhar0ahuGVKx88euHiL956a3NzM67Ga2sbu7v7SZpmaVporY3W49HoUpdlWZZ5UZSlLktjnSMqSh0GweFDi57njdKUyDnr7LBvBv34hS+Up87C1LQdJdnqXdIFYwyQAQEPAkBknJMjICJdujx3We6sBWMJkTefeJJJJZpN5EJOz4h6wzt0RNTrol7n1aqoT3gHFtTcPPcDHsduMOj/5XfD/l4tCoUU9UYD+p1hp/3yz17J85yNIYkxNgb/8Rcyxll7r/3RlWsXHjvvB55Ssr3XPnX67E9f+kmR59VqtdPtlUVJRAhjNEQkuH/9ywh1zmmt8yy31hprk2HaajYOHVxELgbDAQGUG+vR6YekI6MLq7Vut8Eap81/wDnOuB8A4y7PwMEYkl2WuzI3oxFvPv44r9dZGCHjcnIqOPGgNz3Dq1VerctajUUVVN4Y25Fh/vor/OovvCx1wwHv7nWuXelsb1+/djPLMuSMc6aU8n3P96UQQgiulFRSMMYQoD8Y3Lh+46mPPxWEwebG2tmzj7zy859tbGxNT7XmZqfnF+Y3NjbJ/Ud58396EMB4OpBhWWrG2PmHH17f2LBE4Jze221+7leLH3zLNqcxiMgaMtqVJTkLxiLnLAyZkjys8Kgi4ljENeTMDIdm0OfNxy+ySszDiNframp6vhpXTOFb6zmHjDvPZ1IiYwAEr/60/Nvv9W8vKXK1Udd2O7dv3V5dueeIOEPOue97YeBJKTylBOeMsfFHcI6IQrC9vf1ut3f+wnnOeb/Xq1ZrH7z/XlmWYeBPTrYOHz68trFptIb/aLv6u4vxHng/ITCl5kIggO/J06dP3Vq6jchcmoQH5pnWgz/5Pe/8RRbFAOiKnLQBICYljyLu+cwPAAA5RymZ8kgb0+/x5uOPs0osJhpMKf/o8fl+O/q9/91/6QczV96dfeuVA1v3KsnQ5bm+t5J9/zvZzlbr4KF60s3tXuqGU9XJ/f0uQ2Cc+74XR6HvqyDwlZKccwDgjGmtCYgxVpSaHKzcXT1z9qG5udn1tfVHzz/+gx98v8hzItft9SqV6MknLhZl2el0iP6TpYG/nJNx8URERFKpRmPi6JEjK8t3srJA6YEu/Urcf/v1/IO3/SefR993eW56PWRc1Go8jgGRhxE4B5wjF2StiOP01k3eeOxx5vvM81gQqZm54aGjurN/7Ud/c/3yh+srK7vXruBHl9mbrw5uXddZFkz42OuEtr8ib4zi/qHa4ZPHThCR4FivV+v12Pc8pSQBjeOCMbQEzlKWF+PEjgB63e7Tzzzd6/WOHT2xvnZ3arLR7/eHw7Td7nR7nRMnjp8//3CaFcPhkBwhQ/wlUPz/DmtsEPoXH3t0dnb26uXL2jpdlrrXZbosttZ1r1suL/nnLgAyVxTgrKjXmeczJZnyiBzcLz0QrO2/8xZvXrwoJppADj1PNlqy2TLHTiwKjKLQIvZ6vZ2NDdts8dZUnt7Lh/tTJev1d5KFfWjYNtussPjRhy6eOvlgkSWIoKQAAkC01jYazbPnHnnhhRcfOnuGM9zvdsaYt7u79yu/9kVHjqMgslHoPfn42dGgv9vuDIfJxubmcDA4eeLYE09crFQqxloisNYgIo6xlyNDZIJV4sqzzzx94cKF7/3l90ajEec8TTMyRkiZdbvWOr27A4ypw8fBGVeWsl5nUqAQTClApLIc5/VkbXZnSRAiOUsGbJrmq8vewgL4QfezX5rMsubBwwAw2ttJ/LC3c72zduPgsef9/S0nq/1939QzmjE3hu/lrv909bPPfuKFd958rdvpSCW0NbVa7Utf/mqzOam1BsTJyakgjO7cXlq+u2KMWb6zfPDgwd3drdbk9NUP32nUT3z5y5+Lf/TqpTc/NFpv7+xube9UwujYA8c+/cnnK5WYCzYYDNv7nWQ0IoCpyclms2GM7vX6//J/+V8RrKeUEhwRnTFOl0QkhKjX67Wla/HMDHOuSFNRjCiMusceRMZRSHIOAMYlqWw0BVljkhGLKjTsE1G5veUfPKSbk73nPjPx0vcREaNq0l4e7N2dOfp8OOwCQL1enwqfunHjSv/4TrgA+3jvMv30hfgffP5XvvwXf/6NJEkqUXT8xKlTp88KwYkgz7Miz8qynJmbW12955y7fev2wYMHO939Q4tHAZinvEZz5h/+F//osSeXf//3/3Bvr03kev3+22+/S8455zjnUknP88ZZys0bN/M8L8tSay2lbDWqBATAEBGQyGgAYowdOXwkiiJ36ypy7geBStqDXA8eOEVE47gga8lom2VOa964+DjzfOb7AGjzFABVa5L5vmlOonN881436be3Ppw++LRLRlG/M8g7I9Fp1VsPHfxYMAzbbJPN2CF1SZQX5j9RqVSXbl0vivLw4eNK+Uqp/fZet9Pp9/t3l5eBaGtryxh75Ojh1mSz2+3Ozs7funnz4tPPtyZnlV85fuL0M8880+u2NzY2rbXkyDmyzmljsjwfDof9wSBJkizL8rywzgFivVrxlCQi49woyxnnwpNkrO95hw4dkoJXK2EceqYo1rd3i49dSOcOjcktl+cuz22WkdaAyOsXLohq3SQjFIKc41IRkajWmOcVC4eK7a3ejdcbhx7Tt274SopieL24vB1s2zCZq84dnTo5bed23Zqpl1vJetNMnj504dWfv7K5sR1W4pnZ2f12e3+/3dnf39ra3N9vA8D29o7W+pnnPi6FSJPkxInTX//a/1OpxHGtMT1zgHNBZM+d+9jzzz114vghT7JOt+ccWWeNMb9kVpAICEgKUY8j31OcM+soK7S1lisppGTIJGNHDh30fZUXxcbO/k6nGx4+vvfc58YbstPaFYUrSzLGdLu62+UTFy4AFzyMgDHk3J9fsMnQZZmankHGxVuvMq7KrVtptxdzwW2xblf5NGXN0b7emgtmF1rHT0UP39q7msp0K1l+yHusFjdef/2N7e3tahx7fkDkBv3B7dtL1lrr3ObGhjHm81/4bJ5lRDQ/v/i1r3/92rWPyjxNhkPP85qtKSJnrWlM1E6eOH72zIMLB2aiQDnrKpWoEkVh4IeBP1GrTtRi5UnOOSBY5/pJyoVgyvN8X0hRJKPm5ORep7e9t++I4gML7a/+Y1TKZhkZQ9a4LDOjoUsS3dl3acobT1xEqcZ8IQ9CMdHgYRR/7BFUCo1mb/yEsLd64/v15pEoLQmKDbYmJpB7aOJ8y1upe+HDB595uPX45bV3BpV+ci85Nnn6o6sfDfqDm7eWOvv7aZqsr68BoHNuZWVlOBwqL3j6mae63Y5UcnZu4Qd/9Vd5nt29u3zjxs3u/t7mxr1+r8sQERyBW767ypk4dfrBZrPhyDSbE5OtCc6YUhIZjJJcCAEA3f6wtM5TnClPtaZkFJfDQZ4XBOSsC+oTe7/yDzCKmJIuTZ0uqSjsaOiyzOWZzXNwlk88eoGAmPKAMVGtirgq6w1vbg6F5Leuw8q1rbXvWFHW2cFq6XKdbbsNjIgJBoZBrFfxTprsf+bBr56qnnt37dV7yb1DeDyQ4c0btxCx29nv9frO2UG/v3T79mAwYIwdPLg4PTOlS62kOnjwyBuvv56MhhO1oMiz6zeXPrx8ub23297b6/cHnU53NBoaW3Y7nVLrhYX5er0WBqE1dpSknf7ICwNdlmmWJVmOAEJKEQSi3iCyXPlZWXZ2d3qD/kCo2hd/Q9TqKIQd9MkY3dl3eW7TVPe6ZIwrCnafFicC55ALcsSjaJzYsY3lwuybqOPb2BsVQOAJr6Yn+I4q1sF0XboM+Q683X/93/zof4p4/bPV3xqmyY39D+cX5pRS1lhH1Ot1V1burq7dK8sSEa2xx48fS9OEC+75/szM3JgYA4LQVzOTcRSIlbt39tsbghulJMCYtQsaE/F+pxtFURzHURgSUViNuOAEaJy7n2sC+GEoJyYAOQghqrXwwGLl8HFZbzBf8Tges2HIORhD1rosHfPgyEAAAtznKozudlgQurIcqwwOBfo01XoKEsl6vcyR1vqpxedaM41+2s5ZulVu7G5sZd3i5eKVKk1fPPrsTH/xhr750KnH5+ZmV1fv4f1CCZx1AMA55544dHgxTVNP+ecfeeLVV362u7PNGXMEjMAaYohSiI+u3X7yiceKIolCZa0FIufo6OHDSZpywcclrC7JOecFfq8/cDCmqsFTyvZ76PtYFuQcIGNCOGuIiIwG63gldlqzKLJp6ooCGCOjgVAQARozngvT64qoAs6Nc1iVjhBmXJ8AkyLb8SWPokAJNd04cPjAsUaz+dDpc9zD5b2P/u8//Tfffe3PFlqHPn/yK//2O//ncH507NixtbV1RHAOrHX3qyaGjz3+KOe8Uok/8YkXr3/04f/2r/4lAnieRETrHAAY6wAgrlYG/WG1WrV5KQRYY401QnqtVmVzc10pJTkXDAtLBMAZWmAAZEs97HZavpcg055PWQoMgXNnNAsjwPE7JyDH/IBXKqIsdGfflRqABCA6o22WMt9Hxp0ubZ6PCfUq2ntra8uXfpKsb0FhGTDr26Dq1z6oHDlw9FPPvXD0yImF1sFz4cf/xW8v/vzSS+/+9MMXPvXiM6eevXn9+szMrKdUXuTW3hcUpBS1Wv306VNKeWfPnn/t1Z/u7+1+6lPPv/n6JWO0IzDWRWFw7Nih48eOTEzUGWPGkhTSEQBoBbB06+pTH38hSUZpkiIi4wwtI+vCasyzPE8zstaVZXd376Gzp5dzSh0hZ8zzBUMQAqwDRJSSjAFryFpnLSC6siBr+cSFC2AdGAvIeByrqWlvZlbUJ5hS/bdevfb93y1pN1pQB+bmW9X68HDbnSqyA8PV3bWf/vRnL73z49ub1ypR6HKyuZ2enmnv7YUiGg4HZVmmWXrxiYunHzp1e+m2lLxWqz33/LONZuPUqTM7O1t/8o0/+if/7T+7eePq+to9Y2yrUf/Klz7/yU8+c/jwYc9TROQcEYGUXqPZMsYBQbM5cfXKZa2NNXan3XZCMM4A0YxzaimssWEl7PVHSZJ85tknO8AKo12ZVc49Ik6dI2vAGCoLMxy4vAAgRIZCFjvbdtAXY73P5hkq5fKceb7T5Tg6+Be/Mn3td0b35FQ0H+3JqcVWP2v3+L6cB/8oCcsHyxt/9vK3/vR7356uTn/101+NRZhlqbG22Wy123sLC/MTjYkwDIXgZ86eOXb8mOd51Wq93+/97v/xr5999hk/CImInPvkJ5568oknlBcGYYWI2u2dlZXVzqBblsYaqMaNhx56qNdpj0bDxYWFja2t5bsrMgyKLJO+D9J6BIgjR6SUAgLSxd7GxjuXLn3uU0+/v+w624V79ElDBM7ZsrSjBAjGUg7qUsga9307GvKJCxfIEZNS1OosDEUl5lFFNBo8CLyN1eDDu5Frwmq3GsVTkzOnDp3ulduJS6p1rzblebNMzSEC9Huj199+s9cZHjt41OgSAfM8d45+8c4vPrry0fOf/NT0zLTWul6vHzx4+I+/9vt7u7tf+PwXpPLW79354he/eOHxp+NqK661eoPkrbff/ODm5bXeWrts98pON++urNw9eOBYrV6dmjrAGK/W6kLKpCiyrHDOeSdOVc48HC4eZEQuGQJAkefkqNPe9xU/NFWfnZ1K548kcYPK0uWZHY1skQMgEI3LfOZ5djTiExcusCiSjUkeBEAkG01gTE1O8zCU3/mGHBX59ZtgqVKJfd+veLXPnf3yJ049P1OZHOT7W51umthwQagaM4Xb6W6/+cY7UompxmSeF1rrIAwOHzk2SobGmDAMDh48vLa6/Pprr9Sqla/85m/v7m1PthqLh44GQUX58WuXfvbaez/ZLjdTPrTMOEbgQFudZnlVxE89/Yn23jYyNkqSiUZzr7PfH44sJ37yqJyIUchgbkG1JrN7K7o05JyScme7HbUmVwvWf/LTzlhXFLrfpywbs1xkLRgLRExKMxgIVL5sNIFxQkQULAiAAMhBnldc6duib62zLhklE/W6FLLRaJw5+fyvTvx2GFV+fue7//qn/+NHt9cgcNFDLLtFpa9fufXq9vbuEx97DBEJaDAceJ7inMVxxRrz59/6pq/4+fPnG82pWzevnjnzcL0x9d77b7/63g+7umNZicB1ZlOb0kQOM8Yyq2bYR3fef2LjmYnm5PravbwoUWtyjsgMYLT15rfC6dbBM89HrCl1I1hYzNMlZ21cqxZFsdwvwgOTbGPNHVi0oxEVBTlH5GA8ApAzRA6l4JOf/RyTaiyagzWyOYlSqulZ6fu7//M//+DVNzr9Yb/T2293lm7dubV0W0mRjJJarUrOqSyYKg7UqnJvc7/bTrVwyIBLNh/MpcO8UqkopZxzjDMh5OLi4p/96TedLXzf/42vfHVqZrYSRUcf+Nhf/MU3Xr38oxENiOywlw+wS4cT74RWC5a3CJsaJ5zhxe23ls+feaI36BnrnDWb29udYW+r3C5ZUWaD9vK1fNRpHn6QiyBZvq218TyvNdX0Fo6g56OQZqJp08SVmoy5760Yb+xlSdaablfwSuzKkqwBAnBWdzvRg6eZ5zlk3XDi/Je+nHb3q6OeJ2WRFzOzB6anJm/duvH1r3/t1OlTTzxxEUEsDM58vjl701597+aVZJSePnVs0sxmA72+sXlgbm5hcb4oion6xPLSzV5nLwjUs8994sy5xxBhdv7o7/37f3V757pjlnLaHO4GZ3W8yFlgraUSjbaWiIAha4rOYP3b3/na88++aKztFjkijmxS6pL7BAKdNe21m4J7B0+/wKUSorDWARfAGHg+Zqnr98AROOfKAoUEa5zWVOSuyElrQOCTL75IWgMgOOec9eYO+AuLzA9YGNYevZh/+J5LkhpSo14/dOjQI+cfbTZbiwsLHzt7dnNz43d+53eXlm5brWuViVY0M+1N1qD++Nknh71EcNHr9l/6ySs3biyRMdWK/4u333TWtRq1//qf/gsAUl707W//wa2Nqw5NrrPRib2J5y2ftUZojaakMklyz6jYxjWamOazD88/+dTpjy/duD7od7mQ+93uzs6uA0NIDgmBkEGRjWaOnytXN/QoRQS/UhGNFqvUqCxtvWEAEZCMdkVhk4QJYYYDm2Vm0LejkUDkQEDOAZCIqy7PSWsyFgD02r1sNKqbUnAmBK9U4jiO6/WJLMuEFA+ePPnUE49dvnr9b/7mJ7V69YmL5xcXF6eacxGrPv/xF/7dv/33H35wlYCcNcu3rq/fvSUEn5ub+uLnP93rbCNXP/rG7++MNlFgEvb546PqlCPfMCQcYFQ2munMgXDxoDxc4TXJPAbCActGvQdPHLm3vr6xuZOVqcdUlER+Zoxv8kpZBmALk/Z2VXOCbW4xZFSWlGeAiMbw4YDimukPbJYiQ5OMOFHZ3gNrdadDRIIA7sOGsbxSUZOTamqGVyqIaJdvU555znHBlfLCKIrjahhFSnmdzn4yGsZxeOb0iZV76xvr2y+99Mr58+d+/Te+VIniS5fe+OCDKwAgOa+GyjmrDUxPNZ995kkuQ63N66+83O3tE1JS74pzGVQdaDYXHpq3JxbDUzKTVuccOdNccI8zZawxulAqHAwHnh8cOXZ0NxlJ369Vomy/pwtdVXGBZceRHuaOcakUIFpj3bDPrQEAsbWOjUnSJQCUu7sEYHo9staORiYZgXMCEcdOH9loND/1ojd34L56MBqWq3elMwqsUn4URY1m0/d9IYSzzhidF5kU0jkXR1FcjUej0TvvfCClevKpJ7/+R38sGPd8qTgCogOsVaKPnTvbHZTNaf9nP/3xYDiw1m6r9fAEzAdHHxBnZ8XRYBSRBQaMexjWA8bYysrSxtrGfre9u9++t7kZB7Wv/MrfW9va84OgLLWbP1g0JyUxtbej7y55PTgQeLTZtjs7XIgx2QnDvhv0sFKFbtsb9mylQoMhOQdjBdRYAHBZTs6OM0sSURSfO69ak9l3/yS/flVOzzLl29GgQlYCKCl9P2i1JoMw0rocJcPO/l6WpnlRZFleakNEQkjr7HtXrrzy1psgMIxDRs46Bw6Fpx489WBnWM5X/ZWVu6PhEABGanD+/GPH49M11cIMhFDSC+qNhlLhzu7Wu9cuf3TjvTsrdwpXaq61KkqZN/Pmt//ym59/4dfu3l1yDAai2739rorrEwsf84+8SHfujD66rPs3Va2qlEjTnHmBPXrCzcxRa4Y5i+lQHjgMROUuczp3WoMxyJjNUjJGAAEIoWbn/MWD7t7K4E++NvzwPe759U+9SEXhG+0pJYQMwzCKKkEY9Ta725sbo+Ewy7MszUqtS62ttcqThnjqnIgqTHIhRL6zyzgLg/DkyWOFQ1+q3d1dwVkljmZm5x+fe6YsC9M3mUuiMO51R53eyvtX3lrbWdFCm0oBdW0e1Bg48hway3M77LYfoOPvvv/W1NRsKXl/c0VTov/bT9YAABKoSURBVEej7MZOdfJYff5cNL1QvPsGM7njwv/1r4pavRz2TafjOh3ZmpZk+Mmz+dam6fcBwBlNRutux/S6ut8XxFBUa/78gqxP2A9/MTs903Ou+enPBqcezi/9RFrtqdDzvFZrUklV5HlR5Pv77SzLhoNRlmVGG6ONEMLz5ECXQW2CHFGZ2zyXgR976uiRw4yruFIFAC5UqzUxP79YqVY95TWaU7t7u1c+unpnfSkvsiwrNtMd9YCunUYVOGstGKIC7BAPePOL8bEHFh6g1Kyubt68+VF3NAqNsFJZWzpXdNduZhvtxUd+jU/Ptd9/myMzf/bHJhkhonMWkLEgxLJUH7wPs/M2L1yekdZOl3aUZCt3WRQK5JyHkWw0me/r9t6Rkw/eeelHJGRx765yVgL6vhdXq7V6Pa7Wet3OaDjUWleqtUlt86Jsd/rG2kolBICpRjBgihg3I7JloaRqTc0g9/zAY4zXatWpyclGYyIvy8H2bm/YX99Z6ybtQTZMdFrGuTxaThzhJJ0RBBawEAf5wfng+Fx01OVMci5LrY2pxpUgrl5/5fV4yDh4aYxZWBC5fNTu/OKndmW7zIv7bpj7CilwznkQkdHZzWv0/tv48JOOcFxYMt9D39e9ngCCcXEBANQfbAwGJ08/uHRvLWq1KlZHoecpr1qtTU5NT03P7u5tt9vty1evbqxvaqPr9fq5c2dv31keDofgkd+Mjh9eeOvNmwzQb80IKbOiCLWOopALsd/tr6xvjtLUOgfcDW1/BAMdZv5B8qdRoGUBGCmRUBX+aXnuWPRIQLHOzMb6+ubmZrfTPXroUKtR6yf5gYWDujSV5pQsctbdqwR+20vIkN3cTIYJZ0woWeYlEBEQ4xw9j0Z9EpK0lo1JRrYIY6c1FAUwxjwfhkPBwlDUajwIAABt2e4NnnviqdU338Z0qEwZhXUhhO/7B+YXR6PhO2+//dZbbyRJVmhN1q3eW19ausMYO3X+1JCSzJM5gR9UeRAgIOqyTLKs0LrT2+l0BecAoJTkApY7y/xgHjRtwEAzMxyWMuIi56jdo5MXTvlPSBtMRK31tXtvvP36tVu3+qPEMrc93Pmvfuu/3Nh7ZzhKGBc7XMTHz7R0Wa5d9khktrRlyRnzfN84YoI75xgXLKpwpdygR9U67O/JZit69PHOyiqkqXOOHJG1ACB4FIlKTM4hAPghcX51a/s3P/PCd378Y49ZSzTW+N97992/+qu/uHv3bp4XAKC1QQTOuNbGkbvyi6tHTx45vLDw0fKamJzCPIPBgAEwKZgUU9NTtWpUjWPO0Vrj+/6T1Qsj09/ubYySZGAHW7huiiLA8AunvrzgHTuyeOLK9ct/+p0/WtvbWN/dy0FHD3iegmHa30u2UMDW7pb2sL27tLd1a+aBRybPfYrdel+Zdgf6YTU2wnN5To6AAfD7gih5gTOGx1V/8bA3fzAglty+xYhsljPfRwQh6xM8CMFZIIK4ikLsdLKtJPvPPvvi2u0l5amd/X5qVr79vR8M+/2yyJDuOxW0MUYbbSwiEtHa1mZvOKTpRa9asYMBWYfGEEBm7N31LamE53n1ifrkZEugV4kma2zyQO1wUeRpmXCfaavrYePY/MmiLH/vj3735vKttc5u7rRoQXVWgTC2sJmHV1ffn6keuHltOYHSsZJJsXv3igprtRMX4INL3C8cV0V7D6WksSNTCK48ACqzDLXGMFBKMl2KWpUJYbXhSo7BQjitUQgy1q5cy378fTF9gAXBOzdvvdnrYW9fclFmqS9kWebOWmssECEAARltsjwHIuTo1UNVC0ylShNN2GtTvweMkRS+rGCe5aNRWUKSZd0sX9neYYxJyQPJG/X6/Mx0HIZVL5ptTEy2Zj68+sGPf/bXKzvb+1mPFIkqqxzyrNO2dCiZBbeitx6oHxtkowSJMcYFoHTrb/4tPPKJ4Mgp3n/XZhkhIKJXnwiaU6pWqz54BjnPtrdYJeos30l2d5TVolbnlYrTGn5pvxBA5C8u0sa97j/9x2Z/HyvL4aHDICQUmSkKrUcIkJQlQ7TGjkldZ421zjrnnGOSVxcafi0UUuKx00QcG9YOep6jPM+MtZHkltFefyd1I4FSiUCqQArPeJ5O025nXwiplJyOQ2PtzeVbd3Y2CigwIgeuTOzue9abZpV5j0k0qdvLu+1hu9toFmvrUobB9ASvB93k5mh3rfLIMWu0Lst4ds6fmhF+hILzOIYgAOuCmVlAnH78KTszh3FVEKjJKdPrAQA4AkLBo4gVRfd/+O/NfhsAaDQYXfkAPY9Lb+zVIWsBmWMwdi4bY02pkXMHyJBVWrGMPGAIDz1dGhws3WQM1fSMLfLYxlWEUwcX9vd2mDh5beXays7KkLdJo8sJBshJhF508six0K9nRfHBtavrnT1QVjSdiIh5AAzKzOohtd9PeYTBQjWPKz9fubu3Z6Rl/vQR53JGjAmh6lWztyU9X/ghSgnWOWsRCQHMaARcCN9Ho5lzODVjG02232ZC3uclshwQBVOKv/FKmCcsDI0xzjmwlrR22qAQjHECZHhfEjDGOiKmJADYvNDG2lRD4aBesy9+Rbz8N6Je7Vy96vIimJhQXIyMzoaDh06erIZ+JYqPLz5wa/v6eu+ediUT6Al1du7MdG1m1B9euXn9XnuH+SCbTgSAgsmInAMBwDwnNDMFpPfSootlQEJVhd9iTDFiujNkJOvzx+3G1tghi4wDZ1YXLJxgEy1X5K7bhjDg9Sar1cEa5vuyPjGWxW2W2TRBJMGEimu11oUnyuHAFYXR2haFtaZI03I04uTGIpW1tizKoBLHcTRK0kG/7ylPcJGPimqV8Lf/Oz7sqyiuHz6m01G2v5f3hpnWClCn8p0PPqjVa6dPnlyIJ1r1ySQfLW3f2k+3T82dnQhb++39u2srd7e2gJOoEgIwDiIghPEJRAwFCIbAGA9JMM5swGWADMnaIJqde/4JGCYExKR0ACwMHZd60FfGuLU7oywzVmttqsdPekvXVFyF1hQKUbvw+PDyB8XWFpADAIEIg0PHW5de4VFcn5hwebHX7ZRJ4srCQyQiIXgcV6rV6uzc3MWLTyHCSy+9tLS0NBgMi6Jw5Ea5jqOaq9Xzt191WVKZnWec51KaIneW+sNROihGpR6Wl1v1+vREnQycmH7QDx4O/ODu3eXNzc3rqysOLeNU9iCaY14MBG7sFQcEIiADhIgchPJQxtKrQK4RPRHUJg4cdpLb/VXnLDnHG5MU12jtLmyvj7ROR4mxlpxDomF7XyFM7+34/80/d81JclY2mnY4HFv2+NSv/Kp38rRyVqwssyxp37kls1F7dcUUubUmDKOFhfkHHji+sDB/4sSJRx99zJiy1+1KpTzfK/Iiy1JwVggUDz+e/Oxv+qt3huvLye4WMCd8ySTjoYeVwDhbdHvJYJgUBQjPAVaCcHnl9r17azfXVo0sgwkKWsQ4Fn3SGUifS48bA7YkRwjIUAjm+9yvcKYwc9KvkoXGuSdAcre2AnlGAC5PZaVCu5ujtdVBp5vnubP2PzR/EZF1UBbSajh+Wg8Gw/ff7b395th8IoDLYmer/9wLD7z/xs7lG5xcqY22lpxTnhdX4zAMAdHzvDiuSinTNLWOnHOh71eiaDgaomDJX/+FuvjxcHLaJAOm0Loi6+wycKoSSM8H4TkfC+EXSZrdWxn1uijUDa3TXns/7RcsUxUUIQCCiknVEIUrUhrtIw+RCQbGinpMTKFUrjCWEj+eUl5ttLEJTzxtv/kHYDWRY1wyY3rvvzvo9511BOMM+/4sIGNAjgCTJInfe0tceNoJr2zv/p1zUbgi52Ek9tvpvWVd6hyxFB4Po3I4LIsyyzJrrRBCShVXa1qXSZKWZTGW/IuiYADAAJHZv/5zdfBYdf5g0tlwUKDgNsl1OjSDjgwCf6JOXBSWZ0pl/V1PIxPYztuGWb9iiYAcMsEACQUBY0KR8MA60DmzyCgHFgC3VgVVP55RFOsss2XB0sRmKSUJALpBTw9HvW6XiBB5GEVBvYpSqjAsSz3Y3LJ56qyzxoJz7uUfmseeQ8b/zrUpUCoWhPUP3xz2+sNKbbvXH6zeVtWaqtSCai3heOLBB8+ePTcaDsqyWFq62ev1jNa+r0pdjjX/2A9KCby/l28HohKpuFZmo4IGXAnhTbjCdzrLO3tBPWpOVQbtMpU200M9tChc1CQU3ObOZGRz67UYAZB25NABs4QEhBzAFiqKpV+RwYTCKqWg97sIaLodjCpuOKB0ZNs7RZowLlS9MXH8pKxVubXCk4gMg6jywKh79XK6s1WdqENUcTeu0PEzohLfXy8AwmYp6TJYvdOJarfefTfb2kTO7aCfGpOHYdZsXV1e/eQnPz23sDgajdZX7965s7S3tyOE2NneybKUc370yJFoIlrz1Y5hw9VlXlNFb9+WJeeMjOV+gJ50Oi3SrEjTIJK8Yoel85roiHHlAIGFnHnO5DRc0cEsRwXWMGvIMSBGQISMM6mAMckjGrJ8a5crn6iwgqtnP+2++w2zsY9cVA8f8x4Iivbe4PYtmyaVahTPTjMpWRT7janZpz4OQoLR5eET5rtfF6tLydKtX/q9Seh2m/Z2d65cuf7aay5NZj/5Aq9OlFc+gEHfWuN63dd++LeCsWNHDt/b2NxZuYtA1bi6sbmzs7NjjAHAy1evRRPVR55/rvf4Z/zN1fTyy7a94isCkpo8zhRyzmRIRiLlpdZMyInpSp7k4Dn00WrnHAEyUBC0lO4T+gTSInecMxLouBDVGLnkMip7udsdKr/GVaCTxLV3xfOfg1d/bFfuyLiSpslwd00PB2zcSEtkslxyDghEDomQcTKZQaSnP513OkxJGDvdCXl05oy3s1Vsb47urahGk4WV1qMXkuU7lAwtEVlXlmUG7s7W7v762szCwpMXL37x85/3g+DSpUvWWuWp5sREV49mTz/S/vin2akz3tOfVa1W+v4blUrqh7ktcsYZEwwZA8YRANAUmWGEvsctWe4zJsaWawGgmFRMSiLuDFgDhM5qdMaScWCABuR7DRnEpixMnlVf/HU+M8+co8vvMCnyUZJ1+kRu3FMqOBeCcSlReBBWUAhUHgKMvCgp9GD5jk0TvbszriIFEfTanejk2cXf/IcU15gp7Ms/ERONbHfHOcvvu5RsJNmB0ydna7Uzp08HUeXChcempqfX7t2TSg2Ho/pcdWPxsEmGylPEefSJv5+nPPne1yp0N67mo/4eMZ+pkDgnsM4Sk2SzctiGeCoo0hx9GDutuXQondEMAFFyBkS+lB76rSYHHwvp+XWlao4g67ZVsyVm56nMiQi0dkLi3zWDOSBORESObFFiaDgRWAsAKKQb9kc3b+QrK6bXoV92QvD6U09bgjzL5cKiNz0Df/h/ZW9ckhIlFoGQUkqlPF3oihKRFFmabm5s+Z63sHjw2kdX1zfWEZmUHIBUq57OP4BCIuOAEDxwuvL8F8oBL6/f8nxjdI5cIxiigkgDGURiwqU9y5xk6KwhcuQIySEgEScCAknIHDDw4joapVg98Kacgf7asvC8yoWn5OEHgHG3vkrvvkFc6KwokoyAEAAZcs6lp5jgqBRGFQRAPyKAzt1lXRSm2yEAV5YwFj4AEBAIqNjb9Z0r3ntHPfyoq1ZGq9+hpFNmhR/6QRhiteLX8MyRhx44+GC/3/3Wn3xz+e6qEEp5UhvLUpOtXM1WL5DRanKKjRuDg6Dy9/7z/MyF4Z//Ad59zZlURpasYQwckHUAwGRIxaiwXeAhonSOaeLcOmbBWkYIBIh+NWbgKTHhiWk7MsPNNa6krNTE4jGTZTQYQpoyACA3bkAe27IBcJxHkHVkHBj7dymF7vesITMa6sEArBl3wvL6088AMgRUjaZ/4kFZqwMwm/ey3TdVhWUuEQ1XOUlutr8j77y/+/p7t94BSxc+dvHcmYdKXa7d2wQiwRmTtpg9XBYGOXd5DghOl0AOhGJHH3RTJxlk2cYOB2BsrMuPe3KBK0ROJnUmR0JGiCiQxtUxoJCBV5kK1AEsg3K/n+7tciUYl/7sIjt+2g6Grihob5ff+BAYN3lWFiU4AsYYA8aYkAycY36IUYUhsKgKAPsrq3m77bS2gz6QG/cJ8/ozzwECIop63ZuewelpuH2LM5X0biFPkIMpDSKCBsGFVxMmyDaGqzfufISWV1Rcr8brG1tJlnu+xMmmrrTIWptllBfgnE0zPejb4cgBc42j4ugJqOR2f6A8IE3kxu1riAK5jwSocxyT+AhIhtAJykS+PjT7Wba7D4RMCsZY2JqDuQXWmjHDgRkNWZGKm1cckNFaZxrYmENDLriUAgGQc1apAgKPawDU3dkZra5QWZIu/66D7v8FJkZK45jQjpYAAAAASUVORK5CYII='> 1",
      "lastMessageTime": "2021-01-19T09:16:34.581",
      "createTime": "2021-01-14T17:33:54.678467",
      "updateTime": "2021-01-14T17:33:54.678467"
    },
    {
      "serial": "1349175387879043074",
      "contactType": "public",
      "senderId": 4,
      "receiverId": 6,
      "contactName": "测试群6",
      "contactAvatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
      "lastMessage": "热热热",
      "lastMessageTime": "2021-01-18T17:06:08.642",
      "createTime": "2021-01-13T10:04:13.601901",
      "updateTime": "2021-01-13T10:04:13.601901"
    },
    {
      "serial": "1349978606126850050",
      "contactType": "private",
      "senderId": 5,
      "receiverId": 9,
      "contactName": "赵云9",
      "contactAvatar": "http://p5.itc.cn/images01/20201224/4fc9fd34d2e44302b25d16916c4c9fd7.jpeg",
      "lastMessage": "初始化数据",
      "lastMessageTime": "2021-01-15T17:38:58.293",
      "createTime": "2021-01-15T15:15:55.748372",
      "updateTime": "2021-01-15T15:15:55.748372"
    },
    {
      "serial": "1349914129784221697",
      "contactType": "private",
      "senderId": 5,
      "receiverId": 8,
      "contactName": "马六8",
      "contactAvatar": "http://p6.itc.cn/images01/20201224/d682a76d7ac241f0a874e258752d17e7.jpeg",
      "lastMessage": "初始化数据",
      "lastMessageTime": "2021-01-15T17:38:55.441",
      "createTime": "2021-01-15T10:59:43.385742",
      "updateTime": "2021-01-15T10:59:43.385742"
    },
    {
      "serial": "1349976351109636097",
      "contactType": "private",
      "senderId": 5,
      "receiverId": 12,
      "contactName": "琪亚娜12",
      "contactAvatar": "https://img2.woyaogexing.com/2021/01/06/bc78d4216a6746ccaf73f38645389225!400x400.jpeg",
      "lastMessage": "初始化数据",
      "lastMessageTime": "2021-01-15T17:38:48.246",
      "createTime": "2021-01-15T15:06:58.106061",
      "updateTime": "2021-01-15T15:06:58.106061"
    },
    {
      "serial": "1350008090855018497",
      "contactType": "private",
      "senderId": 5,
      "receiverId": 13,
      "contactName": "超级管理员13",
      "contactAvatar": "https://img2.woyaogexing.com/2021/01/06/bc78d4216a6746ccaf73f38645389225!400x400.jpeg",
      "lastMessage": "初始化数据",
      "lastMessageTime": "2021-01-15T17:25:19.397",
      "createTime": "2021-01-15T17:13:05.444873",
      "updateTime": "2021-01-15T17:13:05.444873"
    },
    {
      "serial": "1349889298204196865",
      "contactType": "private",
      "senderId": 5,
      "receiverId": 4,
      "contactName": "王五4",
      "contactAvatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
      "lastMessage": "初始化数据",
      "lastMessageTime": "2021-01-15T17:25:13.536",
      "createTime": "2021-01-15T09:21:03.07113",
      "updateTime": "2021-01-15T09:21:03.07113"
    }
  ]
}
const defaultFrinedList = {
  "code": "200",
  "message": "friends",
  "payload": [
    {
      "serial": "1349264422530105345",
      "fromUserId": 5,
      "toUserId": 8,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "8",
        "userName": "马六8",
        "password": null,
        "salt": null,
        "phone": "19113872143",
        "avatar": "http://p6.itc.cn/images01/20201224/d682a76d7ac241f0a874e258752d17e7.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1349264422530105345",
        "fromUserId": 5,
        "toUserId": 8,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    },
    {
      "serial": "1349976135480467458",
      "fromUserId": 5,
      "toUserId": 12,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "12",
        "userName": "琪亚娜12",
        "password": null,
        "salt": null,
        "phone": "152xxxx1234",
        "avatar": "https://img2.woyaogexing.com/2021/01/06/bc78d4216a6746ccaf73f38645389225!400x400.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1349976135480467458",
        "fromUserId": 5,
        "toUserId": 12,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    },
    {
      "serial": "1349978267143200770",
      "fromUserId": 5,
      "toUserId": 9,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "9",
        "userName": "赵云9",
        "password": null,
        "salt": null,
        "phone": "19113872543",
        "avatar": "http://p5.itc.cn/images01/20201224/4fc9fd34d2e44302b25d16916c4c9fd7.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1349978267143200770",
        "fromUserId": 5,
        "toUserId": 9,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    },
    {
      "serial": "1349991032138321922",
      "fromUserId": 5,
      "toUserId": 13,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "13",
        "userName": "超级管理员13",
        "password": null,
        "salt": null,
        "phone": "138xxxx1234",
        "avatar": "https://img2.woyaogexing.com/2021/01/06/bc78d4216a6746ccaf73f38645389225!400x400.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1349991032138321922",
        "fromUserId": 5,
        "toUserId": 13,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    },
    {
      "serial": "1349991068444217345",
      "fromUserId": 5,
      "toUserId": 14,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "14",
        "userName": "安娜14",
        "password": null,
        "salt": null,
        "phone": "152xxxx1234",
        "avatar": "https://img2.woyaogexing.com/2021/01/06/bc78d4216a6746ccaf73f38645389225!400x400.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1349991068444217345",
        "fromUserId": 5,
        "toUserId": 14,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    },
    {
      "serial": "1349991505612328961",
      "fromUserId": 5,
      "toUserId": 15,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "15",
        "userName": "安娜15",
        "password": null,
        "salt": null,
        "phone": "152xxxx1234",
        "avatar": "https://img2.woyaogexing.com/2021/01/06/bc78d4216a6746ccaf73f38645389225!400x400.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1349991505612328961",
        "fromUserId": 5,
        "toUserId": 15,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    },
    {
      "serial": "1349991626253094914",
      "fromUserId": 5,
      "toUserId": 16,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "16",
        "userName": "安娜16",
        "password": null,
        "salt": null,
        "phone": "152xxxx1234",
        "avatar": "https://img2.woyaogexing.com/2021/01/06/bc78d4216a6746ccaf73f38645389225!400x400.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1349991626253094914",
        "fromUserId": 5,
        "toUserId": 16,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    },
    {
      "serial": "1349992728201613315",
      "fromUserId": 5,
      "toUserId": 17,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "17",
        "userName": "安娜17",
        "password": null,
        "salt": null,
        "phone": "152xxxx1234",
        "avatar": "https://img2.woyaogexing.com/2021/01/06/bc78d4216a6746ccaf73f38645389225!400x400.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1349992728201613315",
        "fromUserId": 5,
        "toUserId": 17,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    },
    {
      "serial": "1349992906946072578",
      "fromUserId": 5,
      "toUserId": 18,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "18",
        "userName": "安娜18",
        "password": null,
        "salt": null,
        "phone": "152xxxx1234",
        "avatar": "https://img2.woyaogexing.com/2021/01/06/bc78d4216a6746ccaf73f38645389225!400x400.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1349992906946072578",
        "fromUserId": 5,
        "toUserId": 18,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    },
    {
      "serial": "1351460319166435330",
      "fromUserId": 5,
      "toUserId": 6,
      "memoName": null,
      "blockFlag": "0",
      "clusterName": "我的好友",
      "friendInfo": {
        "userId": "6",
        "userName": "赵六6",
        "password": null,
        "salt": null,
        "phone": "152xxxx2120",
        "avatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
        "createTime": null,
        "updateTime": null,
        "lockFlag": "0               ",
        "delFlag": null
      },
      "relation": {
        "serial": "1351460319166435330",
        "fromUserId": 5,
        "toUserId": 6,
        "memoName": null,
        "blockFlag": "0",
        "clusterName": "我的好友",
        "createTime": null,
        "updateTime": null,
        "delFlag": null
      }
    }
  ]
}
// 聊天室数据


let asd =
{
  "address": "string",
  "age": 0,
  "answer1": "string",
  "answer2": "string",
  "avatar": "string",
  "cellphone": "string",
  "cloudId": "string",
  "company": "string",
  "description": "string",
  "duty": "string",
  "id": 0,
  "logintimes": 0,
  "moduleId": "string",
  "name": "string",
  "nickname": "string",
  "oldpassword": "string",
  "onlinestateid": 0,
  "password": "string",
  "prefixUserId": 0,
  "privilegeTree": [
    {
      "children": [
        {}
      ],
      "description": "string",
      "id": 0,
      "modify": true,
      "name": "string",
      "permissionString": "string",
      "privilegeCode": "string",
      "privilegeId": 0,
      "softwareId": 0,
      "softwareName": "string",
      "superiorPermissionNumber": 0,
      "systemId": 0,
      "systemName": "string",
      "type": "string",
      "url": "string"
    }
  ],
  "privilegefordataTree": [
    {
      "children": [
        {}
      ],
      "description": "string",
      "id": 0,
      "isModify": 0,
      "name": "string",
      "permissionString": "string",
      "privilegeCode": "string",
      "privilegeId": 0,
      "softwareId": 0,
      "softwareName": "string",
      "superiorPermissionNumber": 0,
      "systemId": 0,
      "systemName": "string",
      "type": "string",
      "url": "string"
    }
  ],
  "privileges": "string",
  "pushclientid": "string",
  "qrstcode": "string",
  "question1": "string",
  "question2": "string",
  "realname": "string",
  "registrationtime": "string",
  "roleIds": [
    0
  ],
  "roleInfos": [
    {
      "addpersonnelnumber": "string",
      "creationtime": "string",
      "customertype": "string",
      "description": "string",
      "downbigcount": 0,
      "isdelete": true,
      "ismodify": true,
      "name": "string",
      "privilegeIds": [
        0
      ],
      "privilegefordataBeans": [
        {
          "acttype": "string",
          "description": "string",
          "isdelete": 0,
          "ismodify": 0,
          "lastmodifypersonnelnumber": "string",
          "lastmodifytime": "2021-09-13T08:28:15.634Z",
          "name": "string",
          "permissionstring": "string",
          "privilegefordatacode": "string",
          "privilegefordataid": 0,
          "softwareid": 0,
          "superiorpermissionnumber": 0,
          "syssource": "string",
          "systemid": 0,
          "type": "string",
          "url": "string"
        }
      ],
      "privilegefordataIds": [
        0
      ],
      "privileges": [
        {
          "description": "string",
          "id": 0,
          "isDelete": true,
          "isModify": true,
          "lastmodifypersonnelnumber": 0,
          "lastmodifytime": "string",
          "name": "string",
          "permissionString": "string",
          "privilegeCode": "string",
          "privilegeId": 0,
          "qrstcode": "string",
          "softwareId": 0,
          "softwareName": "string",
          "superiorPermissionNumber": 0,
          "superiornumberslist": "string",
          "syssource": "string",
          "systemId": 0,
          "systemName": "string",
          "type": "string",
          "url": "string",
          "websitemenunumber": "string"
        }
      ],
      "privilegeset": "string",
      "qrstcode": "string",
      "querybigcount": 0,
      "roleid": 0,
      "rolemanagernumber": "string",
      "roleset": "string",
      "roletype": "string",
      "softwareId": 0,
      "softwareName": "string",
      "subsystemId": 0,
      "subsystemName": "string",
      "superiorrolenumber": "string",
      "syssource": "string",
      "updatetime": "string",
      "uploadbigcount": 0
    }
  ],
  "roleNames": "string",
  "roletype": "string",
  "servicecode": "string",
  "sex": 0,
  "state": "string",
  "syssource": "string",
  "systemBS": "string",
  "type": "string",
  "updatetime": "2021-09-13T08:28:15.634Z",
  "userid": "string"
}